import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-trial-page',
    templateUrl: './trial-page.component.html',
    styleUrls: ['./trial-page.component.css'],
    standalone: false,
})
export class TrialPageComponent {
    @Input() isTrialRun: boolean;
    @Output() onOptionSelected: EventEmitter<boolean> = new EventEmitter();

    handleOptionSelected(option: boolean) {
        this.isTrialRun = option;
        this.onOptionSelected.emit(option);
    }
}
